import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import bgImage from '../assets/bg-image.jpg'; 

function Hero() {
  return (
    <section id="accueil" className="relative min-h-[85vh] flex items-center opacity-0 animate-fadeIn scroll-mt-20 overflow-hidden bg-slate-900">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-900/40 to-transparent"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-2xl">
          <h1 className="text-6xl md:text-8xl font-black text-white mb-8 leading-tight tracking-tight">
            Le Style, <br /> 
            <span className="text-blue-500">La Vision.</span>
          </h1>
          <p className="text-xl text-slate-200 mb-10 leading-relaxed max-w-lg font-light">
            Découvrez notre sélection de montures exclusives, alliant technologie optique avancée et esthétique moderne.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <a 
              href="#products" 
              className="px-10 py-5 bg-blue-600 text-white rounded-2xl font-bold flex items-center gap-3 hover:bg-blue-500 transition-all shadow-2xl shadow-blue-500/20 active:scale-95"
            >
              Voir les montures
              <FiArrowRight />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;